<ssc-layouted-overlay
  (closed)="closed.emit()"
  [title]="title"
  [subtitle]="subtitle"
  [highlightFooter]="footerColor"
  [mode]="mode"
>
  <div content>
    <ng-content></ng-content>
  </div>
  <div secondary-action>
    <visana-lib-button
      *visanaLibShowForBreakpoint="'for-Large-Up'"
      variant="tertiary"
      buttonSize="medium"
      iconName="arrow-sm-left"
      iconPosition="left"
      (click)="closed.emit()"
      data-analytics="insurance-selection-overlay_close"
    >
      {{ 'COMMON.ABORT' | translate }}
    </visana-lib-button>
    <ng-container *visanaLibHideForBreakpoint="'for-XSmall-Down'">
      <visana-lib-button
        (click)="closed.emit()"
        *visanaLibHideForBreakpoint="'for-Large-Up'"
        class="slim"
        buttonSize="small"
        iconName="arrow-sm-left"
        iconPosition="left"
        variant="tertiary"
        data-analytics="insurance-selection-overlay_close"
      >
        {{ 'COMMON.ABORT' | translate }}
      </visana-lib-button>
    </ng-container>
    <visana-lib-background-icon
      (click)="closed.emit()"
      *visanaLibShowForBreakpoint="'for-XSmall-Down'"
      iconSize="16"
      name="arrow-sm-left"
      backgroundColor="transparent"
      data-analytics="insurance-selection-overlay_close"
    ></visana-lib-background-icon>
  </div>

  <div class="contact-btn" #contactBtn contactBtn>
    <ssc-contact-btn [showContactButton]="true"></ssc-contact-btn>
  </div>

  <div *ngIf="selectionMode !== 'not available' && price" class="price-info" priceInfo>
    <div class="price">
      <span class="currency body-5">
        {{ 'COMMON.CURRENCY_PER_MONTH' | translate }}
      </span>
      <span class="amount headline-4" data-cy="monthly-price-info">
        <ssc-price [price]="price"></ssc-price>
      </span>
    </div>
  </div>

  <div *ngIf="selectionMode !== 'not available'" primary-action>
    <visana-lib-button
      (click)="selected.emit()"
      *visanaLibShowForBreakpoint="'for-XXSmall'"
      buttonSize="small"
      variant="primary"
      iconPosition="left"
      [iconName]="selectionMode === 'deselect' ? 'delete' : undefined"
      [disabled]="selectionMode === 'disabled'"
      data-cy="button-overlay-continue"
      data-analytics="insurance-selection-overlay_continue"
    >
      {{ selectButtonText }}
    </visana-lib-button>
    <visana-lib-button
      (click)="selected.emit()"
      *visanaLibHideForBreakpoint="'for-XXSmall'"
      buttonSize="medium"
      variant="primary"
      iconPosition="left"
      [iconName]="selectionMode === 'deselect' ? 'delete' : undefined"
      [disabled]="selectionMode === 'disabled'"
      data-cy="button-overlay-continue"
      data-analytics="insurance-selection-overlay_continue"
    >
      {{ selectButtonText }}
    </visana-lib-button>
  </div>
</ssc-layouted-overlay>
